<template>
  <div class="out_wrap">
    <div class="back_wrap flex_between" style="flex-direction:row-reverse;">
      <div class="center">
        <el-button v-if="mode == 1 && info.is_update == 1" :disabled="info.is_update == 1" type="primary">审核中...</el-button>
        <el-button v-if="mode == 1 && info.is_update != 1 && powerReg('d269165e1ddbf10ddbb5973660075724')" type="primary" @click="editFn">修改信息</el-button>
        <div v-if="mode == 2 && info.is_update != 1">
          <el-button @click="cancelEdit">取消修改</el-button>
          <el-button type="primary" @click="sureEdit('editruleForm')">提交修改</el-button>
        </div>
      </div>
    </div>
    <ZfLayout title="基本信息">
      <div v-if="mode === 1">
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业名称：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.company_name || '' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业税号：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.duty || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">联系人姓名：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.name || '' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">联系人电话：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.mobile || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">联系人邮箱：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.email || '' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业法人：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.legal || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业性质：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.nature_name || '' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">所属行业：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.industry || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业地址：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.address || '' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">企业固话：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.tel || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">服务费率：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.rate || '' }}% <span v-if="info.rate_count > 1" class="active_color ml10 fs12" @click="rateConfig">查看</span></span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">合同编号：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.contract_number || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">纳税规模：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.taxpayer_type == 1 ? '一般纳税人' : '小规模纳税人' }}</span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">签约主体：</span><span class="flex1" style="word-wrap:break-word;">{{ info.companyinfo.channel_name || '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">e签宝授权：</span>
            <span class="flex1" style="word-wrap:break-word;">
              <span v-if="info.esign_config && info.esign_config.auth_status == 2"> 已授权 <a class="active_color ml10 fs12" style="color: red" @click="cancelEsignAuth()">解除授权</a></span>
              <span v-else-if="info.esign_config && info.esign_config.auth_status == 1"> 授权中 <a class="active_color ml10 fs12" :href="info.esign_config.auth_short" target="_blank">去授权</a><a class="active_color ml10 fs12" style="color: red" @click="cancelEsignAuth()">取消授权</a></span>
              <span v-else> 未授权 <a class="active_color ml10 fs12" @click="applyEsignAuth()">申请授权</a></span>
            </span>
          </div>
          <div class="flex1 flex">
            <span class="w150 right inline mr10">授权有效期：</span><span class="flex1" style="word-wrap:break-word;">{{ info.esign_config ? (info.esign_config.auth_end || '') : '' }}</span>
          </div>
        </div>
        <div class="flex_between mb22">
          <div class="flex1 flex">
            <span class="w150 right inline mr10">商户号：</span>
            <span class="flex1" style="word-wrap:break-word;">
              {{ info.companyinfo.mchinfo && info.companyinfo.mchinfo.length && info.companyinfo.mchinfo.join(',') || '' }}
            </span>
          </div>
        </div>
      </div>
      <el-form v-else ref="editruleForm" :model="editInfo" :rules="editrules" label-width="120px">
        <div class="flex_between">
          <el-form-item label="企业名称：" prop="company_name" class="flex1">
            <el-input v-model="editInfo.company_name" type="text" placeholder="请输入企业名称" clearable />
          </el-form-item>
          <el-form-item label="企业税号：" prop="duty" class="flex1">
            <el-input v-model="editInfo.duty" type="text" placeholder="请输入企业税号" clearable />
          </el-form-item>
        </div>
        <div class="flex_between">
          <el-form-item label="联系人姓名：" class="flex1" prop="name">
            <el-input v-model="editInfo.name" type="text" placeholder="请输入联系人姓名" clearable />
          </el-form-item>
          <el-form-item label="联系人电话：" prop="mobile" class="flex1">
            <el-input v-model="editInfo.mobile" type="text" placeholder="请输入联系人电话" maxlength="11" clearable @keyup.native="editInfo.mobile = editInfo.mobile.replace(/[^\d]/g, '')" />
          </el-form-item>
        </div>
        <div class="flex_between">
          <el-form-item label="联系人邮箱：" prop="email" class="flex1">
            <el-input v-model="editInfo.email" type="text" placeholder="请输入联系人邮箱" clearable />
          </el-form-item>
          <el-form-item label="企业法人：" class="flex1" prop="legal">
            <el-input v-model="editInfo.legal" type="text" placeholder="请输入企业法人" clearable />
          </el-form-item>
        </div>
        <div class="flex_between">
          <el-form-item label="企业性质：" class="flex1" prop="nature">
            <el-select v-model="editInfo.nature" clearable filterable class="w100" placeholder="请选择企业性质">
              <el-option v-for="(item) in natureArr" :key="item.id" :label="item.nature" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属行业：" class="flex1" prop="industry">
            <el-input v-model="editInfo.industry" type="text" placeholder="如：金融、互联网、医疗..." clearable />
          </el-form-item>
        </div>
        <div class="flex_between">
          <el-form-item label="企业地址：" class="flex1" prop="address">
            <el-input v-model="editInfo.address" type="text" placeholder="请输入企业地址" clearable />
          </el-form-item>
          <el-form-item label="企业固话：" class="flex1" prop="tel">
            <el-input v-model="editInfo.tel" type="text" placeholder="请输入企业固定电话" clearable />
          </el-form-item>
        </div>
      </el-form>
    </ZfLayout>
    <el-dialog :title="'配置服务费率'" width="600px" :visible.sync="dialogVisible" >
      <table cellspacing="0" cellpadding="0" border="0" class="w100 priceTable mb10 el-table el-table--fit el-table--striped el-table--border el-table--fluid-height el-table--enable-row-hover el-table--enable-row-transition el-table--medium zf-table">
        <thead>
        <tr>
          <th width="28%">生效日期</th>
          <th width="28%">截止日期</th>
          <th width="28%">服务费率(%)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in sectionData" :key="index">
          <td class="center">
            <span>{{ item.effective_date }}</span>
          </td>
          <td class="center">
            <span>{{ item.end_date }}</span>
          </td>
          <td class="center">
            <span>{{ item.rate }}</span>
          </td>
        </tr>
        </tbody>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'申请e签宝签署授权'" :visible.sync="dialogEsignAuthVisible">
      <el-form ref="esignForm" :model="esignForm" :rules="esignRules" class="demo-ruleForm" label-width="160px">
        <el-form-item label="签署人姓名：" prop="user_name">
          <el-input v-model="esignForm.user_name" placeholder="请输入签署人姓名" class="w100" clearable />
        </el-form-item>
        <el-form-item label="签署人身份证号：" prop="idcard">
          <el-input v-model="esignForm.idcard" placeholder="请输入签署人身份证号" class="w100" clearable />
        </el-form-item>
        <el-form-item label="签署人手机号：" prop="user_phone">
          <el-input v-model="esignForm.user_phone" placeholder="请输入签署人手机号" class="w100" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEsignAuthVisible = false">取消</el-button>
        <el-button type="primary" @click="esignAuthSubmit('esignForm')">确定</el-button>
      </div>
    </el-dialog>
    <ZfLayout title="法人身份证" required>
      <div v-if="mode == 1 && info.idcardinfo.length">
        <div v-for="(item, index) in info.idcardinfo" :key="index" class="file_item flex">
          <div class="flex1 ellipsis">{{ item.filename || item.file }}</div>
          <div class="w150">{{ item.filesize }}KB</div>
          <div class="w150">
            <a class="add" @click="previewFile(item)">预览</a>
            <a class="add" target="_blank" :href="baseUrl + '/api/downloadFile?file_code=' + item.code">下载</a>
          </div>
        </div>
      </div>
      <div v-else-if="mode == 1 && !info.idcardinfo.length" class="center c9">暂无数据</div>
      <div v-else>
        <com-upload :arr="editInfo.idcardinfo" @UploadChange="editInfo.idcardinfo = [...$event]" />
      </div>
    </ZfLayout>
    <ZfLayout title="营业执照" required>
      <div v-if="mode == 1 && info.file.length">
        <div v-for="(item, index) in info.file" :key="index" class="file_item flex">
          <div class="flex1 ellipsis">{{ item.filename || item.file }}</div>
          <div class="w150">{{ item.filesize }}KB</div>
          <div class="w150">
            <a class="add" @click="previewFile(item)">预览</a>
            <a class="add" target="_blank" :href="baseUrl + '/api/downloadFile?file_code=' + item.code">下载</a>
          </div>
        </div>
      </div>
      <div v-else-if="mode == 1 && !info.file.length" class="center c9">暂无数据</div>
      <div v-else>
        <com-upload :arr="editInfo.file" @UploadChange="editInfo.file = [...$event]" />
      </div>
    </ZfLayout>
    <ZfLayout title="业务合同" required>
      <div v-if="mode == 1 && info.contract.length">
        <div v-for="(item, index) in info.contract" :key="index" class="file_item flex">
          <div class="flex1 ellipsis">{{ item.filename || item.file }}</div>
          <div class="w150">{{ item.filesize }}KB</div>
          <div class="w150">
            <a class="add" @click="previewFile(item)">预览</a>
            <a class="add" target="_blank" :href="baseUrl + '/api/downloadFile?file_code=' + item.code">下载</a>
          </div>
        </div>
      </div>
      <div v-else-if="mode == 1 && !info.contract.length" class="center c9">暂无数据</div>
      <div v-else>
        <com-upload :arr="editInfo.contract" @UploadChange="editInfo.contract = [...$event]" />
      </div>
    </ZfLayout>
    <ZfLayout title="一般纳税人">
      <div v-if="mode == 1 && info.taxpayer.length">
        <div v-for="(item, index) in info.taxpayer" :key="index" class="file_item flex">
          <div class="flex1 ellipsis">{{ item.filename || item.file }}</div>
          <div class="w150">{{ item.filesize }}KB</div>
          <div class="w150">
            <a class="add" @click="previewFile(item)">预览</a>
            <a class="add" target="_blank" :href="baseUrl + '/api/downloadFile?file_code=' + item.code">下载</a>
          </div>
        </div>
      </div>
      <div v-else-if="mode == 1 && !info.taxpayer.length" class="center c9">暂无数据</div>
      <div v-else>
        <com-upload :arr="editInfo.taxpayer" @UploadChange="editInfo.taxpayer = [...$event]" />
      </div>
    </ZfLayout>
  </div>
</template>

<script>
import ZfLayout from '@/components/ZfLayout/index'
import ComUpload from '@/components/upload'
import { natureList } from '@/api/common'
import { companyEdit, customerDetail, updateCompany, rateConfigList, applyEsignAuth, cancelEsignAuth } from '@/api/accountInfo'
import { isPuXing } from '@/utils/fn'
import { get } from '@/utils/storage'
export default {
  components: {
    ZfLayout,
    ComUpload
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (value !== '' && value !== undefined) {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value !== '' && value !== undefined) {
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      dialogEsignAuthVisible: false,
      sectionData: [],
      mode: 1, // 1-查看 2-修改 基本信息
      editInfo: {},
      natureArr: [],
      editrules: {
        company_name: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        duty: [{ required: true, message: '请输入税号', trigger: 'change' }],
        name: [{ required: true, message: '请输入联系人姓名', trigger: 'change' }],
        mobile: [{ required: true, message: '请输入联系人电话', trigger: 'change' }, { validator: validateMobile, trigger: 'change' }],
        legal: [{ required: true, message: '请输入企业法人', trigger: 'change' }],
        nature: [{ required: true, message: '请选择企业性质', trigger: 'change' }],
        industry: [{ required: true, message: '请输入企业所属行业', trigger: 'change' }],
        address: [{ required: true, message: '请输入企业地址', trigger: 'change' }],
        tel: [{ required: true, message: '请输入企业固话', trigger: 'change' }],
        email: [{ required: true, message: '请输入企业邮箱', trigger: 'change' }, { validator: validateEmail, trigger: 'change' }]
      },
      esignForm: {
        user_name: '',
        idcard: '',
        user_phone: ''
      },
      esignRules: {
        user_name: [{ required: true, message: '请输入签署人姓名', trigger: 'change' }],
        idcard: [{ required: true, message: '请输入签署人身份证号', trigger: 'change' }],
        user_phone: [{ required: true, message: '请输入签署人手机号', trigger: 'change' }]
      },
      // baseUrl: isPuXing() ? process.env.VUE_APP_PUXING_BASE_API : process.env.VUE_APP_BASE_API,
      baseUrl: '',
      company_id: this.$route.query.company_id,
      info: {
        companyinfo: {},
        contract: [],
        file: [],
        idcardinfo: [],
        taxpayer: [],
        rate_count: 0
      },
      optionMch: []
    }
  },
  mounted() {
    this.detail()
    natureList().then(res => {
      if (res.code === 200) {
        this.natureArr = res.data
      }
    })
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      if (isPuXing()) {
        this.baseUrl = process.env.VUE_APP_PUXING_BASE_API
      } else {
        this.baseUrl = process.env.VUE_APP_BASE_API
      }
    } else {
      this.baseUrl = process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    get,
    previewFile(item) {
      // window.open(`${process.env.VUE_APP_IMAGEVIEW}/onlinePreview?url=${item.fullpath || item.file || item.contract}`)
      window.open(`${process.env.VUE_APP_IMAGEVIEW}${encodeURIComponent(this.base64Encode(item.fullpath || item.file || item.contract))}`)
    },
    async detail() {
      const res = await customerDetail()
      if (res.code === 200) {
        this.info = res.data
      }
    },
    editFn() {
      this.mode = 2
      this.editInfo = {
        ...this.info.companyinfo,
        nature: this.info.companyinfo.nature === null ? '' : +this.info.companyinfo.nature,
        idcardinfo: [...this.info.idcardinfo],
        file: [...this.info.file],
        contract: [...this.info.contract],
        taxpayer: [...this.info.taxpayer]
      }
    },
    cancelEdit() {
      this.mode = 1
    },
    sureEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editInfo.idcardinfo.length) {
            this.$message.error('请上传法人身份证')
            return
          }
          if (!this.editInfo.file.length) {
            this.$message.error('请上传营业执照')
            return
          }
          if (!this.editInfo.contract.length) {
            this.$message.error('请上业务合同')
            return
          }
          const postData = {
            company_id: this.editInfo.company_id,
            // mch: this.editInfo.mchinfo, // 商户号
            // rate: this.editInfo.rate, // 服务费率
            company_name: this.editInfo.company_name,
            duty: this.editInfo.duty,
            name: this.editInfo.name,
            mobile: this.editInfo.mobile,
            email: this.editInfo.email,
            legal: this.editInfo.legal,
            nature: this.editInfo.nature,
            industry: this.editInfo.industry,
            address: this.editInfo.address,
            tel: this.editInfo.tel,
            idcardinfo: [...this.editInfo.idcardinfo.map(d => d.code).filter(d => d)],
            file: [...this.editInfo.file.map(d => d.code).filter(d => d)],
            contract: [...this.editInfo.contract.map(d => d.code).filter(d => d)],
            taxpayer: [...this.editInfo.taxpayer.map(d => d.code).filter(d => d)]
          }
          if (this.info.companyinfo.status == 1) {
            updateCompany(postData).then(res => {
              if (res.code === 200) {
                this.$message({ type: 'success', message: '修改成功' })
                this.detail()
                this.mode = 1
              }
            })
          } else {
            companyEdit(postData).then(res => {
              if (res.code === 200) {
                this.$message({ type: 'success', message: '提交成功,等待审核' })
                this.detail()
                this.mode = 1
              }
            })
          }
        }
      })
    },
    async queryRateConfig() {
      const res = await rateConfigList({ company_id: this.$route.query.company_id })
      if (res.code === 200) {
        this.sectionData = res.data
      }
    },
    rateConfig() {
      if (this.sectionData.length == 0) {
        this.queryRateConfig()
      }
      this.dialogVisible = true
    },
    // 创建授权
    async applyEsignAuth() {
      this.dialogEsignAuthVisible = true
      this.esignForm.user_name = ''
      this.esignForm.idcard = ''
      this.esignForm.user_phone = ''
    },
    async esignAuthSubmit() {
      const res = await applyEsignAuth(this.esignForm)
      this.dialogEsignAuthVisible = false
      if (res.code === 200) {
        this.detail()
      }
    },
    // 取消授权
    async cancelEsignAuth() {
      const res = await cancelEsignAuth()
      if (res.code === 200) {
        this.detail()
      }
    }
  }
}
</script>

<style></style>
